import React from "react";
import { useTranslation } from "react-i18next";

import {
  classifySportsbookTemplate,
  ProviderTemplate,
  sportsbookTemplateLabel,
  SportsbookMechanic,
} from "helpers/sportsbookRewardMechanics";
export type { ProviderTemplate } from "helpers/sportsbookRewardMechanics";
export type TemplateOption = {
  value: string;
  label: string;
  providerTemplate?: ProviderTemplate;
  mechanic?: SportsbookMechanic;
};

export function templateOption(
  id: unknown,
  label: string,
  template?: ProviderTemplate,
): TemplateOption {
  return {
    value: String(id),
    label: sportsbookTemplateLabel(label, template),
    mechanic: classifySportsbookTemplate(template),
    providerTemplate: template,
  };
}

function renderRules(value: unknown): React.ReactNode {
  if (value === null || value === undefined) return "—";
  if (Array.isArray(value))
    return (
      <ul>
        {value.map((item, index) => (
          <li key={index}>{renderRules(item)}</li>
        ))}
      </ul>
    );
  if (typeof value !== "object") return String(value);
  return (
    <dl>
      {Object.entries(value).map(([key, item]) => (
        <React.Fragment key={key}>
          <dt>{key.replaceAll("_", " ")}</dt>
          <dd>{renderRules(item)}</dd>
        </React.Fragment>
      ))}
    </dl>
  );
}

export default function SportsbookTemplateDetails({
  template,
}: {
  template?: ProviderTemplate;
}) {
  const { t } = useTranslation();
  if (!template) return null;
  return (
    <details>
      <summary>{t("sportsbookTemplateRules")}</summary>
      {renderRules(template)}
    </details>
  );
}
